import { CampaignDetailModelState } from '@urbanx/agx.campaigns.client';

export const shouldShowBlankContractProgress = (
  campaignState: CampaignDetailModelState | undefined,
  automateLiveListings: boolean | undefined
) => campaignState !== CampaignDetailModelState.NSW && !!automateLiveListings;
